<template>
	
	<div class="compass" :class="{ 'compass--collapsed': collapseMenu }">
		
		<div class="sidebar">
			
			<div class="sidebar__column sidebar__column-logo">
				<img class="sidebar__logo" src="@/assets/logo.svg" alt="Compass" title="Compass" @click="onClickLogo">
				<!--<router-link tag="div" to="/my-profile">-->
				<el-dropdown @command="onClickUserDropdown">
					<div class="sidebar__profile-picture">
						<ion-icon name="person"></ion-icon>
					</div>
					<el-dropdown-menu slot="dropdown">
						<!--<el-dropdown-item command="my-profile"><ion-icon name="person"></ion-icon>Profile</el-dropdown-item>-->
						<el-dropdown-item command="logout"><ion-icon name="exit"></ion-icon>Log Out</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<!--</router-link>-->
			</div>
			
			<div class="sidebar__column sidebar__column-navigation">
				<div class="sidebar__brand-outer">
					<h1 class="sidebar__brand">COMPASS</h1>
				</div>
				<ul class="sidebar__links">
					<li v-for="route in $router.options.routes" v-if="route.meta.menu && authorised(route)" :class="{ 'sidebar__link': true, 'sidebar__link--active': topLevelPath == route.path }" :title="route.meta.title" @click="clickMenuItem(route)"><ion-icon v-if="route.meta.icon" :name="route.meta.icon"></ion-icon><span>{{ route.meta.title }}</span></li>
				</ul>
			</div>
			
		</div>
		
		<router-view v-if="$auth.check()" class="content-area" key="home"/>
		
		<TimeBookStopWatch class="card card--shadow" :small="true" :floating="true" :showDropdowns="true" :floatingVisible="$store.state.timebook.recording"/>
		
	</div>
	
</template>

<script>

	import TimeBookStopWatch from "@/components/TimeBook/StopWatch";
	
	export default {
		
		name: "Compass",
		
		components: { TimeBookStopWatch },
		
		computed: {
			
			topLevelPath() {
				return this.$route.matched[0].path;
			}
			
		},
		
		methods: {
			
			onClickLogo() {
				this.collapseMenu = !this.collapseMenu;
				if (localStorage) {
					localStorage.setItem("collapseCompassMenu", this.collapseMenu);
				}
			},
			
			onClickUserDropdown(action) {
				if (action == "my-profile") {
					this.$router.push("/my-profile");
				} else if (action == "logout") {
					this.$confirm("Are you sure you want to log out?", "Confirmation", {
						confirmButtonText: "Yes",
						cancelButtonText: "Cancel",
					}).then(() => {
						this.$auth.logout({
							success: () => {
								this.$store.commit("loggedIn", this.$auth.check());
							}
						});
					}).catch(() => {
						
					});
				}
			},
			
			authorised(route) {
				if (route.meta.auth) {
					return this.$auth.check(route.meta.auth);
				}
				return true;
			},
			
			clickMenuItem: function(route) {
				
				// Variables.
				
				let segments = route.path.split("/");
				let mainMenu = (segments.length == 1);
				let subMenu = (segments.length == 2);
				
				// Main menu or sub menu?
				
				//if (mainMenu) {
					if (route.name == "logout") {
						this.$refs.confirmLogoutPopup.open();
						return false;
					} else {
						this.$router.push(route.path);
					}
				//} else if (subMenu) {
				//	this.$router.push({name: name, params: {slug: segments[1]}});
				//}
				
			}
			
		},
		
		data() {
			
			return {
				collapseMenu: false,
			}
			
		},
		
		mounted() {
			
			if (localStorage && localStorage.getItem("collapseCompassMenu")) {
				this.collapseMenu = localStorage.getItem("collapseCompassMenu");
			}
			
		}
		
	}
	
</script>

<style lang="scss">
	
	
	
</style>



// WEBPACK FOOTER //
// src/components/Compass.vue